class RiskService {
  constructor(publicKey) {
    this.publicKey = publicKey;
    this.riskInstance = null;
    this.initializing = null;
  }

  async init() {
    if (this.riskInstance) {
      return this.riskInstance;
    }

    if (this.initializing) {
      return this.initializing;
    }

    if (typeof window === "undefined" || !window.Risk) {
      return null;
    }

    this.initializing = window.Risk.create(this.publicKey)
      .then((risk) => {
        this.riskInstance = risk;
        return risk;
      })
      .catch(() => null)
      .finally(() => {
        this.initializing = null;
      });

    return this.initializing;
  }

  async getSessionId() {
    try {
      const risk = await this.init();

      if (!risk || typeof risk.publishRiskData !== "function") {
        return null;
      }

      const sessionId = await risk.publishRiskData();
      return typeof sessionId === "string" ? sessionId : null;
    } catch (e) {
      return null;
    }
  }
}

export default RiskService;
